function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function () {
  'use strict';

  // routes:
  // /settings/measures
  // /settings/measures/:measureId
  //
  // services:
  // MeasurePermissionSvc
  //
  // controllers:
  // MeasureSettingsCtrl
  // AssociatedReportsModalCtrl
  // MeasureListCtrl
  // MeasureEditorCtrl
  // MeasurePermissionsCtrl
  // MeasureCategoriesCtrl
  // MeasureCategoryModalCtrl
  // MeasureMenuCtrl
  angular.module('wsLrs.controllers').service('MeasurePermissionSvc', ['$q', 'AppPermissions', 'Measures', 'Logger', function ($q, AppPermissions, Measures, Logger) {
    var self = {
      __measures: null,
      __permissionMap: null,
      fetch: function fetch() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            countReports: false
          },
          _limit = _ref._limit,
          _offset = _ref._offset,
          countReports = _ref.countReports,
          searchText = _ref.searchText,
          order_by = _ref.order_by;
        return Measures.list({
          _limit: _limit,
          _offset: _offset,
          countReports: countReports,
          searchText: searchText,
          order_by: order_by
        }).then(function getMeasuresSuccess(data) {
          self.__measures = data.results;
          return self.fetchPermissions().then(function getPermissionsSuccess() {
            // map permissions onto each measure object
            _.each(self.__measures, function (measure) {
              measure.permissions = self.get(measure.id);
            });
            return {
              count: data.count,
              measures: self.__measures
            };
          });
        }, function getMeasuresError(response) {
          self.__measures = null;
          Logger.error("Measures fetch failed with response status " + response.status);
          return [];
        });
      },
      fetchPermissions: function fetchPermissions() {
        if (!self.__permissionMap) {
          self.__permissionMap = {};
          return AppPermissions.getPermissions('measure').then(function getPermissionsSuccess(measurePermissions) {
            self.__permissionMap = measurePermissions;
          });
        } else {
          return $q.resolve();
        }
      },
      get: function get(id) {
        return {
          permissions: self.getPermissions(id),
          people: self.getPeople(id),
          groups: self.getGroups(id),
          hasGlobalGroup: self.getHasGlobalGroup(id)
        };
      },
      getPermissions: function getPermissions(id) {
        return _.has(self.__permissionMap, id) ? self.__permissionMap[id].permissions : [];
      },
      getPeople: function getPeople(id) {
        return _.has(self.__permissionMap, id) ? self.__permissionMap[id].people : [];
      },
      getGroups: function getGroups(id) {
        return _.has(self.__permissionMap, id) ? self.__permissionMap[id].groups : [];
      },
      getHasGlobalGroup: function getHasGlobalGroup(id) {
        return !_.isUndefined(_.find(self.getGroups(id), function (g) {
          return g.id === -1;
        }));
      },
      save: function save(id, permissions, people, groups) {
        var entityParams = {
          value: 'measure',
          entityId: id
        };
        return AppPermissions.multiSave(permissions, {
          params: entityParams
        }).then(function saveMeasurePermissionsSuccess() {
          return self.set(id, permissions, people, groups);
        }, function saveMeasurePermissionsError(response) {
          Logger.error("Error updating measure permissions, response status " + response.status);
          return {};
        });
      },
      set: function set(id, permissions, people, groups) {
        if (!_.has(self.__permissionMap, id)) {
          if (!self.__permissionMap) {
            self.__permissionMap = {};
          }
          self.__permissionMap[id] = {
            permissions: [],
            people: [],
            groups: []
          };
        }
        var entityPermissions = self.__permissionMap[id];
        if (_.isArray(permissions)) {
          entityPermissions.permissions = permissions;
        }
        if (_.isArray(people)) {
          entityPermissions.people = _.sortBy(people, 'name');
        }
        if (_.isArray(groups)) {
          entityPermissions.groups = _.sortBy(groups, 'name');
        }
        return entityPermissions;
      },
      // todo: does removing measure also remove its appPermissions?
      remove: function remove(id) {
        delete self.__permissionMap[id];
      },
      updateMeasures: function updateMeasures() {
        Measures.update();
        return self.fetch();
      }
    };
    return self;
  }]).config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/settings/measures', {
      templateUrl: 'modules/app/settings/measures/measure-settings.html',
      controller: 'MeasureSettingsCtrl',
      requiredPermissions: ['admin', 'manager']
    }).when('/settings/measures/:measureId', {
      templateUrl: 'modules/app/settings/measures/measure-editor.html',
      controller: 'MeasureEditorCtrl',
      requiredPermissions: ['admin', 'manager']
    });
  }]).controller('MeasureSettingsCtrl', ['$scope', 'UserRoles', 'User', function ($scope, UserRoles, User) {
    $scope.section = "measures";
    $scope.isAreaAdmin = UserRoles.isOrgAdmin(User.get());
  }]).controller('AssociatedReportsModalCtrl', ['$scope', 'Measures', 'CardUtils', '$location', function ($scope, Measures, CardUtils, $location) {
    $scope.CardUtils = CardUtils;
    $scope.navigateToReport = function (report) {
      // First close modal, then navigate to report
      $scope.$close();
      $location.path("/".concat(report.template.name, "/").concat(report.id));
    };
    Measures.get($scope.measureForAssociatedReports.id).then(function (_ref2) {
      var reports = _ref2.reports;
      $scope.reports = reports;
    });
  }]).controller('MeasureListCtrl', ["$scope", 'Measures', '$location', 'ConfirmModal', '$http', 'Api', '$q', '$timeout', 'wsEventNames', 'MeasurePermissionSvc', '$filter', '$uibModal', function ($scope, Measures, $location, ConfirmModal, $http, Api, $q, $timeout, wsEventNames, MeasurePermissionSvc, $filter, $uibModal) {
    $scope.$emit("headline:change", "Settings");
    $scope.$emit("nav:change", "settings");
    $scope.section = "measures";
    $scope.measures = [];
    $scope.sortControls = [{
      "title": "Measure",
      "options": {
        "Name Ascending": "name",
        "Name Descending": "-name"
      }
    }, {
      "title": "Reports"
    }, {
      "title": "View Permission"
    }, {
      "title": "Category",
      "options": {
        "Measure Category Name Ascending": "measureCategory.name",
        "Measure Category Name Descending": "-measureCategory.name"
      }
    }, {
      "title": "Updated",
      "options": {
        "Last Updated Ascending": "updated",
        "Last Updated Descending": "-updated"
      }
    }];
    $scope.sortBy = "name";
    $scope.defaultSortBy = "name";
    $scope.useLegacySearchParams = true;
    $scope.loadAssociatedReports = function loadAssociatedReports(measure) {
      $scope.measureForAssociatedReports = measure;
      return $uibModal.open({
        templateUrl: 'modules/app/settings/measures/modals/associated-reports.html',
        controller: 'AssociatedReportsModalCtrl',
        scope: $scope
      });
    };
    $scope.deleteMeasure = function deleteMeasure(measure) {
      var body;
      var confirmBtn;
      if (measure.reportCount) {
        body = "This will remove this measure from the ".concat(measure.reportCount, " report").concat(measure.reportCount > 1 ? 's' : '', " it is used on. Are you sure?");
        confirmBtn = "Delete and remove from reports";
      } else {
        body = "Are you sure?";
        confirmBtn = "Delete";
      }
      var deleteModal = {
        title: "Delete Custom measure " + measure.name,
        body: body,
        cancelBtn: "Cancel",
        confirmBtn: confirmBtn,
        confirm: function confirm() {
          $http.delete(Api.url("/measures/" + measure.id)).then(function () {
            //refresh UI
            $scope.setMeasurePage(0);
          });
        },
        cancel: function cancel() {}
      };
      ConfirmModal.open($scope, deleteModal);
    };
    $scope.isLoading = false;
    $scope.fetchData = function fetchData(params) {
      $scope.isLoading = true;
      var defer = $q.defer();
      var _params = Object.assign({}, params, {
        searchText: params.searchTerm || "",
        countReports: true
      });
      return MeasurePermissionSvc.fetch(_params).then(function (_ref3) {
        var count = _ref3.count,
          measures = _ref3.measures;
        $scope.isLoading = false;
        $scope.measures = measures;
        defer.resolve({
          count: count
        });
        return defer.promise;
      });
    };
    $scope.fetchMeasurePage = function (offset, limit) {
      $scope.isLoading = true;
      var params = {
        _limit: limit,
        _offset: offset,
        countReports: true,
        searchText: $scope.search.name
      };
      var defer = $q.defer();
      return MeasurePermissionSvc.fetch(params).then(function (_ref4) {
        var count = _ref4.count,
          measures = _ref4.measures;
        $scope.isLoading = false;
        $scope.measures = measures;
        defer.resolve({
          count: count
        });
        return defer.promise;
      });
    };
    var prevSearchTerm = '';
    $scope.updateSearchTerm = function updateSearchTerm() {
      if ($scope.searchTerm !== prevSearchTerm) {
        $scope.$broadcast(wsEventNames.pager.setPage, 1);
        prevSearchTerm = $scope.searchTerm;
      }
    };
    $scope.setMeasurePage = function setMeasurePage() {
      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      $scope.$broadcast(wsEventNames.pager.setPage, p);
    };
    $scope.formatPermissionsDisplay = function (d) {
      if (d.hasGlobalGroup) {
        return "All groups and people";
      } else {
        var groupDisplay, peopleDisplay;
        if (d.groups && d.groups.length > 0) {
          groupDisplay = d.groups.length + " group" + (d.groups.length > 1 ? "s" : "");
        }
        if (d.people && d.people.length > 0) {
          peopleDisplay = d.people.length + (d.people.length > 1 ? " people" : " person");
        }
        if (groupDisplay && peopleDisplay) {
          return groupDisplay + ", " + peopleDisplay;
        } else {
          if (groupDisplay) {
            return groupDisplay;
          } else {
            return peopleDisplay;
          }
        }
      }
    };
  }]).controller('MeasureEditorCtrl', ['$scope', '$routeParams', 'Api', '$http', 'ConfirmModal', '$location', 'CardQueryResource', 'AggregationUtils', 'MeasureRegistry', 'MeasurePermissionSvc', 'CardRegistry', function ($scope, $routeParams, Api, $http, ConfirmModal, $location, CardQueryResource, AggUtils, MeasureRegistry, PermissionSvc, CardRegistry) {
    $scope.measure = {};
    $scope.advancedConfig = false;

    /* Filters */

    var _setFilters = function setFilters(val, key, obj, not) {
      if (key === 'not') {
        _.each(val, function (val, key) {
          _setFilters(val, key, null, true);
        });
      } else if (key === "equals") {
        _.each(val, function (v) {
          var combinedIds = "";
          _.each(v.values.ids, function (id) {
            combinedIds += id + ',';
          });
          combinedIds = combinedIds.slice(0, -1); //remove last comma

          var filterKey = _.findWhere($scope.filterKeys, {
            id: "equals"
          });
          $scope.filters.push({
            key: filterKey,
            equalsField: v.fieldName,
            equalsFieldType: v.fieldType,
            value: combinedIds,
            regExp: v.values && v.values.regExp,
            not: not
          });
        });
      } else if (_.pluck($scope.filterKeys, 'id').indexOf(key) !== -1) {
        var ids = val.ids ? val.ids : val;
        _.each(ids, function (id) {
          var filterKey = _.findWhere($scope.filterKeys, {
            id: key
          }) || {
            id: key,
            name: key
          };
          $scope.filters.push({
            key: filterKey,
            value: {
              id: id,
              name: id
            },
            regExp: val.regExp,
            not: not
          });
        });
      } else {
        $scope.advancedFilters[key] = val;
      }
    };
    var updateFilters = function updateFilters(pFilter) {
      var filter = {};

      // If a filter is passed in from ace editor, we want to populate client side filters from it
      // Also check against arrays as the debounce for updated filters in UI passes an array object in
      if (!_.isNull(pFilter) && !_.isUndefined(pFilter) && !Array.isArray(pFilter) && Object.keys(pFilter.length !== 0)) {
        $scope.filters = [];
        _.each($scope.measure.config.filter, _setFilters);
      }
      _.each($scope.filters, function (f) {
        if (f.not && !filter.hasOwnProperty('not')) {
          filter.not = {};
        }
        var property = f.not ? filter.not : filter,
          key = f.key.id;

        //does this property need an IdList object?
        var isIdList = _.contains(["activityIds", "verbIds", "parentActivityIds", "groupingActivityIds", "contextActivityIds"], key);

        //add property if it doesn't exists
        if (!property.hasOwnProperty(key)) {
          if (isIdList) {
            property[key] = {
              "ids": [],
              "regExp": f.regExp
            };
          } else {
            property[key] = [];
          }
        }
        if (key === "equals") {
          if (!f.value) {
            return;
          }
          if (_.isEmpty(property.equals)) {
            property.equals = [];
          }
          if (_typeof(f.value) !== "object") {
            var ids = f.value.split(",");
            // Special case, avoid splitting on commas for object descriptions
            if (f.equalsField && f.equalsField.includes("object.definition.description")) {
              ids = [f.value];
            }
            property.equals.push({
              fieldName: f.equalsField,
              fieldType: f.equalsFieldType,
              values: {
                ids: ids.map(function (id) {
                  return id.trim();
                }),
                regExp: f.regExp
              }
            });
          }
          return;
        } else {
          //get the list so we can add the value to it
          if (isIdList) {
            property = property[key].ids;
          } else {
            property = property[key];
          }
        }
        if (!f.value) {
          return;
        }
        if (!_.isUndefined(f.value.id)) {
          property.push(f.value.id);
        } else {
          property.push(f.value);
        }
      });
      _.each($scope.advancedFilters, function (val, key) {
        filter[key] = val;
      });
      $scope.measure.config.filter = filter;
    };
    $scope.filters = [];
    $scope.advancedFilters = {};
    $scope.filterKeys = [{
      "id": "activityIds",
      "name": "Activity"
    }, {
      "id": "activityTypes",
      "name": "Activity Types"
    }, {
      "id": "verbIds",
      "name": "Verb"
    }, {
      "id": "personIds",
      "name": "Person"
    }, {
      "id": "groupIds",
      "name": "Group"
    }, {
      "id": "equals",
      "name": "Other"
    }];

    // Create a "none" category with a value of null
    $scope.noneCategory = {
      name: "None",
      id: null
    };
    var initCategories = function initCategories() {
      $http.get(Api.url("/measure-categories")).then(function (r) {
        $scope.categories = r.data.results;
        $scope.categories.unshift($scope.noneCategory);

        // attach category
        if ($scope.measure.measureCategoryName) {
          $scope.measure.measureCategory = _.findWhere($scope.categories, {
            name: $scope.measure.measureCategoryName
          });
        } else {
          $scope.measure.measureCategory = $scope.noneCategory;
        }
      });
    };
    var measureId = $routeParams.measureId;
    var editPeople = [];
    var editGroups = [];
    var editPermissions = [];
    $scope.editPeopleAndGroups = [];
    if (measureId !== "new" && _.isFinite(measureId)) {
      $http.get(Api.url("/measures/" + measureId), {
        params: {
          countReports: true
        }
      }).then(function (r) {
        $scope.measure = r.data;
        $scope.originalEntity = angular.copy(r.data);
        $scope.originalName = $scope.measure.name;
        _.each($scope.measure.config.filter, _setFilters);
        PermissionSvc.fetchPermissions().then(function getPermissionsSuccess() {
          $scope.measure.permissions = PermissionSvc.get(measureId);
          editPeople = _.clone($scope.measure.permissions.people);
          editGroups = _.clone($scope.measure.permissions.groups);
          editPermissions = _.clone($scope.measure.permissions.permissions);
          $scope.editPeopleAndGroups = [].concat(editPeople, editGroups);
        });
        initCategories();
      });
    } else {
      var copyMeasure = $routeParams.copy;
      if (copyMeasure) {
        if (_.isFinite(copyMeasure)) {
          $http.get(Api.url("/measures/" + copyMeasure)).then(function (r) {
            $scope.measure = r.data;
            delete $scope.measure.id;
            delete $scope.measure.created;
            delete $scope.measure.updated;
            $scope.measure.name = $scope.measure.name;
            _.each($scope.measure.config.filter, _setFilters);
          });
        } else {
          copyMeasure = JSON.parse(copyMeasure);
          $scope.measure.name = 'Copy of ' + copyMeasure.name;
          $scope.measure.visibility = 'everyone';
          $scope.measure.config = copyMeasure;
          _.each($scope.measure.config.filter, _setFilters);
        }
      } else {
        $scope.measure = {
          visibility: 'everyone',
          config: {}
        };
      }
      initCategories();
    }
    $scope.getFilterTypeahead = function (key, val) {
      if (!key || !key.id) {
        return [];
      }

      //TODO: implement searching for people, groups and activities by other fields (ids, descriptions etc)
      switch (key.id) {
        case "verbIds":
          return $http.get(Api.url('/acc/verbs'), {
            params: {
              in_display: val,
              order_by: "display",
              _limit: 10
            }
          }).then(function (r) {
            return _.map(r.data.results, function (d) {
              return {
                id: d.verbId,
                name: d.display
              };
            });
          });
        case "activityIds":
          return $http.get(Api.url('/acc/activities'), {
            params: {
              in_name: val,
              order_by: "name",
              _limit: 10
            }
          }).then(function (r) {
            return _.map(r.data.results, function (d) {
              return {
                id: d.activityId,
                name: d.name
              };
            });
          });
        case "personIds":
          return $http.get(Api.url('people'), {
            params: {
              "in_name": val,
              "order_by": "name",
              "_limit": 10
            }
          }).then(function (r) {
            return r.data.results;
          });
        case "groupIds":
          return $http.get(Api.url("/groups"), {
            params: {
              "in_name": val,
              "order_by": "name",
              "_limit": 10
            }
          }).then(function (r) {
            return r.data.results;
          });
        default:
          //equals filter
          return [];
      }
    };

    /* Value producer */

    $scope.valueProducers = [{
      id: 'STATEMENT_PROPERTY',
      name: 'Statement property'
    }, {
      id: 'TIME',
      name: 'Time period'
    }];
    $scope.valueProducerStatementProperties = ["id", "actor.objectType", "actors.person.id", "actors.groups.id", "actor.name", "actor.mbox", "acotr.mbox_sha1sum", "actor.openid", "actor.account.name", "actor.account.homePage", "verb.id", "verb.display", "verb.name", "object.id", "object.objectType", "object.definition.name", "object.definition.description", "object.definition.type", "object.definition.moreInfo", "object.definition.interactionType", "object.definition.correctResponsesPattern", "object.definition.choices", "object.definition.scale", "object.definition.source", "object.definition.target", "object.definition.steps", "object.definition.extensions", "object.name", "object.mbox", "object.mbox_sha1sum", "object.openid", "object.account.name", "object.account.homePage", "object.result", "object.context", "object.timestamp", "result.success", "result.completion", "result.response", "result.duration", "result.durationCentiseconds", "result.score.raw", "result.score.scaled", "result.score.min", "result.score.max", "result.extensions", "context.registration", "context.instructor", "context.team", "context.revision", "context.platform", "context.language", "context.statement", "context.contextActivities.parent.id", "context.contextActivities.grouping.id", "context.contextActivities.other.id", "context.extensions", "timestamp", "stored", "authority.name", "version"];
    $scope.valueProducerTimePeriods = ['DAY', 'WEEK', 'MONTH', 'YEAR'];

    /* Aggregation */

    $scope.aggregations = [{
      id: 'COUNT',
      name: 'Count',
      description: 'Counts the number of occurrences of the chosen value above.'
    }, {
      id: 'DISTINCT_COUNT',
      name: 'Distinct count',
      description: 'Counts the number of unique occurrences of the chosen value above.'
    }, {
      id: 'SUM',
      name: 'Sum',
      description: 'Adds all the values together'
    }, {
      id: 'AVERAGE',
      name: 'Average',
      description: 'Adds all the values together then divides by the number of occurrences.'
    }, {
      id: 'FIRST',
      name: 'First',
      description: 'Returns the first value in chronological order.'
    }, {
      id: 'LAST',
      name: 'Last',
      description: 'Returns the last value in chronological order.'
    }, {
      id: 'MIN',
      name: 'Minimum',
      description: 'Returns the minimum value.'
    }, {
      id: 'MAX',
      name: 'Maximum',
      description: 'Returns the maximum value.'
    }, {
      id: 'LIST',
      name: 'List',
      description: 'Returns all the values.'
    }, {
      id: 'SET',
      name: 'Set',
      description: 'Returns all the unique values.'
    }];
    $scope.getAggregtionDescription = function (type) {
      if (!type) {
        return null;
      }
      var agg = _.findWhere($scope.aggregations, {
        id: type
      });
      if (!agg) {
        return null;
      }
      return agg.description;
    };

    /* Visibility */

    $scope.visibilities = [{
      id: "everyone",
      name: 'Everyone with Permission'
    }, {
      id: 'none',
      name: 'Hidden'
    }];

    /*  Advances editor */

    var setEditor = function setEditor() {
      // Remove measureCategory & permissions because they can easily get too large and
      // aren't the primary focus of the advanced measure editor anyway.
      var modifiedEditorMeasure = angular.copy($scope.measure);
      delete modifiedEditorMeasure.measureCategory;
      delete modifiedEditorMeasure.permissions;
      $scope.editor.setValue(angular.toJson(modifiedEditorMeasure, 2), -1);
    };
    $scope.showAdvanced = function () {
      $scope.advancedConfig = true;
      setEditor();
    };
    $scope.showSimple = function () {
      $scope.advancedConfig = false;
    };
    $scope.aceLoaded = function (_editor) {
      $scope.editor = _editor;
      var session = _editor.getSession();
      session.setMode("ace/mode/json");
      session.setTabSize(2);
      session.setUseSoftTabs(true);
    };
    $scope.aceChanged = _.debounce($scope.$safeApply.bind($scope, function () {
      updateMeasureFromAceEditor();
    }), 2000);
    function updateMeasureFromAceEditor() {
      try {
        // Append the measureCategory and permissions that we removed in
        // the setEditor() function so we don't lose that data.
        var editorMeasure = JSON.parse($scope.editor.getValue());
        editorMeasure.measureCategory = $scope.measure.measureCategory;
        editorMeasure.permissions = $scope.measure.permissions;
        $scope.measure = editorMeasure;
        if ($scope.advancedConfig && Object.keys($scope.editor.getSession().getAnnotations()).length === 0) {
          updateFilters($scope.measure.config.filter);
        }
      } catch (e) {
        if (e.name === 'SyntaxError') {
          return; // Disregard
        } else {
          throw e;
        }
      }
    }

    /* Preview */

    $scope.$watch('filters', _.debounce(updateFilters, 1000), true);
    $scope.$watch('measure.config', _.debounce(function () {
      var config = $scope.measure.config;
      if (_.isEmpty(config) || _.isEmpty(config.valueProducer) || _.isEmpty(config.aggregation)) {
        return;
      }
      $scope.initializedMeasureEditor = true;
      CardQueryResource.getWithProgress({
        path: "/measures/preview",
        params: {
          measure: JSON.stringify($scope.measure),
          order_by: '-measure[0].value',
          _limit: 5
        },
        progressChannel: 'preview-measure'
      }).then(function (r) {
        $scope.previewResponse = r.results[0].result.data;
      });
    }, 1000), true);
    $scope.displayMeasureValue = function (value) {
      return AggUtils.getMeasureValueDisplay(value, $scope.measure.config);
    };

    /* Save and validation */

    $scope.$watch('measure', _.debounce(function (oldValue, newValue) {
      //disable the save button until the measure is changed
      if ($scope.initializedMeasureEditor || oldValue.measureCategory !== newValue.measureCategory) {
        $scope.measureChanged = true;
      }
    }, 100), true);
    $scope.saveMeasure = function (id) {
      $scope.measureId = id;
      delete $scope.measure.id;

      // If we have the special null category, null out the object before persisting
      if ($scope.measure.measureCategory && $scope.measure.measureCategory.name === $scope.noneCategory.name) {
        $scope.measure.measureCategory = null;
      }
      delete $scope.measure.config.id;
      (id ? $http.put : $http.post)(Api.url('/measures' + (id ? '/' + id : '')), $scope.measure).then(function (r) {
        if (r.status !== 204) {
          $scope.measure = r.data;
        } else {
          $scope.measure.id = $scope.measureId;
        }
        MeasureRegistry.add($scope.measure);

        // if no permission changes, all done
        if ($scope.permissionsChanged || !id) {
          _.forEach(editPermissions, function (p) {
            if (_.isUndefined(p.entityId)) {
              p.entityId = $scope.measure.id;
            }
          });
          PermissionSvc.save($scope.measure.id, editPermissions, editPeople, editGroups).then(function savePermissionsSuccess(permissions) {
            $scope.measure.permissions = permissions;
          });
        }

        // Clear the card registry so users don't have to refresh the page
        // in order to see their measure changes affect their reports.
        CardRegistry.clear();
        $location.path("/settings/measures");
      }, function (e) {
        $scope.error = e.message;
      });
    };
    var openSaveModal = function openSaveModal(isCopy) {
      var id = !isCopy && $scope.measure.id,
        bodyText = "",
        confirmText = "Save";
      if (id) {
        if ($scope.measure.reportCount) {
          bodyText = "This will update the measure and the ".concat($scope.measure.reportCount, " report").concat($scope.measure.reportCount > 1 ? 's' : '', " it is used on. Are you sure?");
          confirmText += " and update all reports it is used on";
        } else {
          bodyText = "Are you sure?";
        }
      } else {
        bodyText = "This will create a new measure. Are you sure?";
      }
      var modal = {
        title: "Save custom measure: " + $scope.measure.name,
        body: bodyText,
        cancelBtn: "Cancel",
        optionBtn: id ? "Save as new measure" : null,
        confirmBtn: confirmText,
        confirm: function confirm() {
          $scope.saveMeasure(id);
        },
        cancel: function cancel() {},
        option: id ? function () {
          $scope.saveMeasure(null);
        } : null
      };

      // Don't prompt for confirmation if ONLY the category changed
      if ($scope.originalEntity) {
        var originalWithoutCategory = _.clone($scope.originalEntity);
        delete originalWithoutCategory.measureCategory;
        delete originalWithoutCategory.measureCategoryName;
        delete originalWithoutCategory.permissions;
        var updateWithoutCategory = _.clone($scope.measure);
        delete updateWithoutCategory.measureCategory;
        delete updateWithoutCategory.measureCategoryName;
        delete updateWithoutCategory.permissions;
        var onlyCategoryChanged = !$scope.permissionsChanged && $scope.originalEntity.measureCategory !== $scope.measure.measureCategory && angular.equals(originalWithoutCategory, updateWithoutCategory);
        if (onlyCategoryChanged) {
          modal.confirm();
        } else {
          ConfirmModal.open($scope, modal);
        }
      } else {
        ConfirmModal.open($scope, modal);
      }
    };
    var validate = function validate() {
      var error = "";
      var config = $scope.measure.config;
      if (!$scope.measure.name) {
        error += "Please specify a Name for this measure. ";
      } else {
        if (!config.name) {
          config.name = $scope.measure.name;
        }
      }
      if (!config.valueProducer || !config.valueProducer.type) {
        error += "Please specify a Value. ";
      }
      if (!config.aggregation || !config.aggregation.type) {
        error += "Please specify an Aggregation. ";
      }
      if (error) {
        $scope.error = error;
        return false;
      } else {
        $scope.error = "";
        return true;
      }
    };
    $scope.save = function (isCopy) {
      updateFilters();
      // Make sure that if they click "save" before the debounced "aceChanged" function
      // is called, that we still update the measure before checking & saving
      updateMeasureFromAceEditor();
      if (validate()) {
        openSaveModal(isCopy);
      }
    };
    $scope.saveAsCopy = function saveAsCopy() {
      if ($scope.originalName === $scope.measure.name) {
        var modal = {
          title: "Save As New Measure",
          subtitle: "You have not changed the measure title.",
          body: "Are you sure you want to save this as a new measure?",
          cancelBtn: "Return to Editing",
          confirmBtn: "Save New Measure",
          confirm: saveMeasureCopy
        };
        ConfirmModal.open($scope, modal);
      } else {
        saveMeasureCopy();
      }
      function saveMeasureCopy() {
        $scope.save(true);
      }
    };
    $scope.addPermission = function addPermission(target) {
      var newPermission = {
        value: 'measure',
        entityId: $scope.measure.id
      };
      if (_.has(target, 'childGroupIds')) {
        editGroups.push(target);
        editPermissions.push(_.extend(newPermission, {
          groupId: target.id
        }));
      } else {
        editPeople.push(target);
        editPermissions.push(_.extend(newPermission, {
          personId: target.id
        }));
      }
      $scope.editPeopleAndGroups = [].concat(editPeople, editGroups);
      $scope.permissionsChanged = havePermissionsChanged();
      $scope.measureChanged = true;
    };
    $scope.removePermission = function removePermission(target) {
      if (_.has(target, 'childGroupIds')) {
        editGroups = _.reject(editGroups, function (o) {
          return o.id === target.id;
        });
        editPermissions = _.reject(editPermissions, function (p) {
          return p.groupId === target.id;
        });
      } else {
        editPeople = _.reject(editPeople, function (o) {
          return o.id === target.id;
        });
        editPermissions = _.reject(editPermissions, function (p) {
          return p.personId === target.id;
        });
      }
      $scope.editPeopleAndGroups = [].concat(editPeople, editGroups);
      $scope.permissionsChanged = havePermissionsChanged();
      $scope.measureChanged = true;
    };

    // $scope.editPeopleAndGroups is not updated prior to Add or Remove actions,
    // so we check for changes by comparing the ids in people and group arrays directly
    var havePermissionsChanged = function havePermissionsChanged() {
      var id = $scope.measure.id;
      return !_.isEqual(_.pluck(PermissionSvc.getGroups(id), 'id'), _.pluck(editGroups, 'id')) || !_.isEqual(_.pluck(PermissionSvc.getPeople(id), 'id'), _.pluck(editPeople, 'id'));
    };
  }]).controller('MeasurePermissionsCtrl', ['$scope', '$controller', '$q', '$http', 'Api', 'MeasurePermissionSvc', 'Alerts', 'People', function ($scope, $controller, $q, $http, Api, MeasurePermissionSvc, Alerts, People) {
    $scope.searchPlaceholder = "Search for a person or group to see their Measure Permissions";
    $scope.permissionEntitySelected = function (entity) {
      $scope.loading = true;
      // Get the categories and groups for the selected person/group
      var cfg = {
        value: "measure"
      };
      $scope.entityId = entity.id;
      $scope.originalEntity = angular.copy(entity);
      var dataCalls;
      if (entity.personas) {
        cfg.personId = entity.id;
        $scope.isPerson = true;
        dataCalls = $q.all([MeasurePermissionSvc.fetch(), People.getPeopleWithMemberships({
          params: {
            id: entity.id
          }
        })]);
      } else {
        cfg.groupId = entity.id;
        $scope.isPerson = false;
        dataCalls = $q.all([MeasurePermissionSvc.fetch()]);
      }
      dataCalls.then(function (responses) {
        $scope.measures = responses[0].measures || [];
        $scope.isOrgAdmin = false;
        if (responses.length > 1) {
          var userWithMemberships = responses[1];
          if (userWithMemberships.count === 1 && userWithMemberships.results[0].membership && userWithMemberships.results[0].membership.role === "admin") {
            $scope.isOrgAdmin = true;
          }
        }
        // Clear out all permission info when cached locally
        _.each($scope.measures, function (d) {
          delete d.hasPermission;
          delete d.directPermission;
        });
        if (!$scope.isOrgAdmin) {
          var url;
          if ($scope.isPerson) {
            url = Api.url("/people/" + $scope.entityId + "/app-permissions?value=measure");
          } else {
            url = Api.url("/groups/" + $scope.entityId + "/app-permissions/include-implicit?value=measure");
          }

          // Decorate the measures objects with permission info from the selected person/group
          $http.get(url).then(function (response) {
            var measurePermissions = response.data;
            $scope.permittedMeasuresCount = measurePermissions.length;
            $scope.indirectPermittedMeasuresCount = 0;
            _.forEach(measurePermissions, function (measurePermission) {
              // Find the measure
              var measure = _.findWhere($scope.measures, {
                id: measurePermission.entityId
              });
              if (measure !== undefined && measure !== null) {
                measure.hasPermission = true;
                if ($scope.isPerson && measurePermission.personId && measurePermission.personId === $scope.entityId) {
                  measure.directPermission = true;
                } else if (!$scope.isPerson && measurePermission.groupId && measurePermission.groupId === $scope.entityId) {
                  measure.directPermission = true;
                } else {
                  $scope.indirectPermittedMeasuresCount++;
                }
              }
            });
            var _cols = 3;
            $scope.measureRows = makeRows($scope.measures, _cols);
            $scope.loading = false;
          });
        }
      });
    };
    $scope.save = function () {
      var permittedMeasureIds = [];
      _.forEach($scope.measures, function (measure) {
        if (measure.directPermission) {
          permittedMeasureIds.push(measure.id);
        }
      });
      $http.post(Api.url("/app-permissions/update-measure-permissions?_limit=1000&" + ($scope.isPerson ? "personId=" : "groupId=") + $scope.entityId), {
        entityId: $scope.entityId,
        measureIds: permittedMeasureIds
      }).then(function success() {
        updateCachedPermissions($scope.originalEntity, $scope.isPerson, permittedMeasureIds);
        Alerts.raiseAlert({
          type: "success",
          text: $scope.permissionEntity.name + " measure permissions updated"
        });
      });
    };
    var updateCachedPermissions = function updateCachedPermissions(entity, isPerson, permittedMeasureIds) {
      _.each(MeasurePermissionSvc.__permissionMap, function (permission, measureId) {
        measureId = parseInt(measureId);
        // Add if missing
        if (_.contains(permittedMeasureIds, measureId)) {
          if (!_.contains(isPerson ? permission.peopleIds : permission.groupIds, entity.id)) {
            if (isPerson) {
              if (!Array.isArray(permission.peopleIds)) {
                permission.peopleIds = [];
              }
              permission.peopleIds.push(entity.id);
              if (!Array.isArray(permission.people)) {
                permission.people = [];
              }
              permission.people.push(entity);
            } else {
              if (!Array.isArray(permission.groupIds)) {
                permission.groupIds = [];
              }
              permission.groupIds.push(entity.id);
              if (!Array.isArray(permission.groups)) {
                permission.groups = [];
              }
              permission.groups.push(entity);
            }
          }
        } else {
          // remove if needed
          if (_.contains(isPerson ? permission.peopleIds : permission.groupIds, entity.id)) {
            if (isPerson) {
              permission.peopleIds = _.without(permission.peopleIds || [], entity.id);
              permission.people = _.filter(permission.people || [], function (person) {
                return person.id !== entity.id;
              });
            } else {
              permission.groupIds = _.without(permission.groupIds || [], entity.id);
              permission.groups = _.filter(permission.groups || [], function (group) {
                return group.id !== entity.id;
              });
            }
          }
        }
      });
    };
    $scope.cancel = function () {
      $scope.permissionEntity = null;
    };
    function makeRowPartition(count, cols) {
      var _d = Math.floor(count / cols);
      var _r = count % cols;
      return Array.from({
        length: cols
      }, function (_, i) {
        return i < _r ? _d + 1 : _d;
      }).reduce(function (a, x) {
        return [a[0] + x].concat(_toConsumableArray(a));
      }, [0]).reverse().reduce(function (a, x, i, arr) {
        return [].concat(_toConsumableArray(a), [typeof arr[i + 1] === 'undefined' ? undefined : [x, arr[i + 1]]]);
      }, []).filter(function (x) {
        return x !== undefined;
      });
    }
    function makeRows(arr, cols) {
      return makeRowPartition(arr.length, cols).map(function (part) {
        return arr.slice.apply(arr, _toConsumableArray(part));
      });
    }
  }]).controller('MeasureCategoriesCtrl', ['$scope', '$controller', '$q', '$http', 'Api', '$timeout', 'wsEventNames', '$filter', 'ConfirmModal', '$uibModal', function ($scope, $controller, $q, $http, Api, $timeout, wsEventNames, $filter, ConfirmModal, $uibModal) {
    $scope.addEditCategory = function addEditCategory(category) {
      var scope = $scope.$new();
      scope.cat = category;
      $uibModal.open({
        templateUrl: 'modules/app/settings/measures/modals/add-edit-category.html',
        controller: 'MeasureCategoryModalCtrl',
        backdrop: 'static',
        scope: scope
      });
    };
    $scope.deleteCategory = function deleteCategory(cat) {
      var deleteModal = {
        title: "Delete Measure Category " + cat.name,
        body: "Are you sure you want to delete " + cat.name + "?",
        cancelBtn: "Cancel",
        confirmBtn: "Delete",
        confirm: function confirm() {
          $http.delete(Api.url("/measure-categories/" + cat.id)).then(function () {
            //refresh UI
            $scope.setCategoryPage(0);
          });
        },
        cancel: function cancel() {}
      };
      ConfirmModal.open($scope, deleteModal);
    };
    $scope.fetchCategoryPage = function (offset, limit) {
      $scope.limit = limit || 10;
      $scope.offset = offset || 0;
      var defer = $q.defer();
      return $http.get(Api.url("/measure-categories")).then(function (response) {
        $scope.categories = response.data.results;
        defer.resolve({
          count: $filter('filter')($scope.categories, $scope.search).length
        });
        return defer.promise;
      });
    };
    $scope.setCategoryPage = function setCategoryPage() {
      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      $scope.$broadcast(wsEventNames.pager.setPage, p);
    };
    $scope.search = {};
    $scope.$watch('search.name', function () {
      $scope.$broadcast(wsEventNames.pager.setPage, 1);
    });
    $scope.formatCategoryMeasureTooltip = function (cat) {
      var html = "<p><strong>Measure Category " + cat.name + " is associated<br/> with the following measures:</strong></p>";
      _.each(cat.measures, function (m) {
        html += m.name + "<br/>";
      });
      return html;
    };
    $scope.$on("category-added-event", function categoryAdded() {
      $scope.$broadcast(wsEventNames.pager.setPage, "last");
    });
  }]).controller('MeasureCategoryModalCtrl', ['$scope', '$uibModalInstance', 'CardGroup', 'Logger', 'MeasurePermissionSvc', 'User', 'Validation', 'wsEventNames', 'UserRoles', 'GroupUtils', '$http', 'Api', function ($scope, $uibModalInstance, CardGroup, Logger, PermissionSvc, User, Validation, wsEventNames, UserRoles, GroupUtils, $http, Api) {
    $scope.action = "Add";
    var user = User.get();
    $scope.newCategory = {
      name: "",
      organization: user.organization,
      id: null
    };
    if ($scope.cat) {
      _.extend($scope.newCategory, $scope.cat);
      $scope.action = "Edit";
    }
    $scope.priorName = $scope.newCategory.name;
    $scope.save = function save() {
      $scope.saveCategoryError = null;
      $scope.saveCategoryProgress = "Saving changes to  " + $scope.newCategory.name + "...";
      $scope.sending = true;
      $scope.categoryFormErrors = Validation.validate({
        "name": {
          "rules": {
            "required": true
          },
          "value": $scope.newCategory.name
        }
      });
      if ($scope.categoryFormErrors !== null) {
        $scope.saveCategoryProgress = null;
        $scope.sending = false;
        return;
      }
      function saveCategoryError(response) {
        $scope.saveCategoryProgress = null;
        Logger.error("Error " + $scope.action.toLowerCase() + "ing measure category " + $scope.newCategory.name + ", response status " + response.status);
        $scope.saveCategoryError = "There was error " + $scope.action.toLowerCase() + "ing the measure category";
        if (response.status === 409) {
          $scope.saveCategoryError = "A measure category with this name already exists in your" + " organization";
        }
        $scope.sending = false;
      }

      // If there's an id, this is an update, otherwise we are creating with a POST
      if ($scope.newCategory.id) {
        $http.put(Api.url("/measure-categories/" + $scope.newCategory.id), $scope.newCategory).then(function saveCategorySuccess() {
          $uibModalInstance.close();
          $scope.cat.name = $scope.newCategory.name;
          return;
        }, saveCategoryError);
      } else {
        $http.post(Api.url("/measure-categories"), $scope.newCategory).then(function saveCategorySuccess(createdCategory) {
          // update displayed category object with new values
          if ($scope.cat) {
            _.extend($scope.cat, createdCategory);
          }
          $scope.$emit("category-added-event");
          $uibModalInstance.close();
          return;
        }, saveCategoryError);
      }
    };
    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
  }]).controller('MeasureMenuCtrl', ['$scope', '$controller', '$q', '$http', 'Api', 'Utils', 'MeasureRegistry', 'Alerts', function ($scope, $controller, $q, $http, Api, Utils, MeasureRegistry, Alerts) {
    MeasureRegistry.prepareMeasures({
      _includeCategories: true
    }).then(function () {
      var res = MeasureRegistry.getAll({
        _full: true,
        _includeCategories: true
      });
      $scope.measures = res.measures;
      $scope.categories = res.categories;

      // Pull out top level menu items
      var menuItems = $scope.measures.filter(function (m) {
        return m.measureCategoryName === "None";
      });
      menuItems = _.sortBy(menuItems.concat($scope.categories), 'menuPosition');

      // Yes, we are calling categories "measures" at the top level here just
      // for consistency -- at the top level it can be either measures or categories
      var topLevelMenu = {
        name: "Measure Menu",
        measures: menuItems,
        id: -1,
        isMainMenu: true
      };
      $scope.menuItems = [topLevelMenu];
      $scope.selectedMenu = topLevelMenu; // default upon load

      // Add all the categories as well
      $scope.menuItems = $scope.menuItems.concat($scope.categories);
      $scope.$watch('selectedMenu.measures', function (newItem, oldItem) {
        // IF the change was simply due to selecting a different change, don't persist.  We
        // are just interested in ordering changes
        if (!newItem || !oldItem || newItem.id !== oldItem.id) {
          return;
        }
        var orderMatches = true;
        var hasUninitializedMenuItem = false;
        if (newItem.length !== oldItem.length) {
          return;
        }
        for (var i = 0; i < newItem.length; i++) {
          orderMatches = orderMatches && newItem[i].menuPosition !== 0 && newItem[i].menuPosition === oldItem[i].menuPosition;
        }
        for (var j = 0; j < newItem.length; j++) {
          if (newItem[j].menuPosition === 0) {
            hasUninitializedMenuItem = true;
            break;
          }
        }
        if (orderMatches && !hasUninitializedMenuItem) {
          return;
        }
        if ($scope.selectedMenu.isMainMenu) {
          $http.put(Api.url("/measures/update-measure-order"), $scope.selectedMenu).then(function saveCategorySuccess() {
            if (!hasUninitializedMenuItem) {
              Alerts.raiseAlert({
                type: "success",
                text: "Measure order updated."
              });
            }
          });
        } else {
          $http.put(Api.url("/measure-categories/" + $scope.selectedMenu.id), $scope.selectedMenu).then(function saveCategorySuccess() {
            if (!hasUninitializedMenuItem) {
              Alerts.raiseAlert({
                type: "success",
                text: "Measure order updated."
              });
            }
          });
        }
      }, true);
    });
    $scope.alphabetize = function () {
      $scope.selectedMenu.measures = _.sortBy($scope.measures, function (item) {
        return item.name.toLowerCase();
      });
    };
  }]);
})();
